<template>
  <ul class="detail-form" v-if="list">
    <li v-for="val in list" :key="val.key">
      <div class="detail-item">
        <div class="detail-label">{{val.label}}</div>
        <div class="detail-value" v-if="val.scopedSlot">
          <slot :name="val.scopedSlot" v-bind:value="val"></slot>
        </div>
        <div class="detail-value" v-else-if="val.file && val.value && val.value.length > 0">
          <div class="detail-file-list">
            <div class="detail-file-item" v-for="(f, i) in val.value" :key="i" @click="preview(f)">
              <img class="detail-file-img" :src="f.url" v-if="f.type == 'image'">
              <img class="detail-file-img" :src="require(`../assets/file/${f.type}.png`)" v-else>
              <div class="detail-file-info">
                <div class="detail-file-name">{{f.fileName}}</div>
                <div class="detail-file-size">{{f.sizeText}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail-value" v-else>{{val.value || '无'}}</div>
      </div>
    </li>
    <slot></slot>
  </ul>
</template>

<script>
    export default{
        name: "detail-view",
        props: {
            list: Array
        },
        methods: {
            preview(f) {
                if(f.type == 'image') {
                    this.$emit("preview", f)
                } else {
                    window.open(f.url, '_blank');
                }
            }
        }
    }
</script>

<style lang="less">
  .detail-form {
    margin-bottom: 0;
  }
  .detail-item {
    display: flex;
    padding: 6px 24px;
    background-color: @component-background;
    line-height: 1.4;
    &.vertical {
      flex-direction: column;
      .detail-value {
        margin: 10px 0 0;
      }
    }
  }
  .detail-label {
    min-width: 60px;
    color: @text-color-secondary;
  }
  .detail-value {
    flex: 1;
    margin-left: 20px;
    min-width: 0;
    word-break: break-word;
    color: @text-color;
    text-align: justify;
  }

  .detail-file-item {
    display: flex;
    align-items: center;
    padding: 8px;
    max-width: 380px;
    border-radius: 4px;
    background-color: @background-color-base;
    cursor: pointer;
  }

  .detail-file-item:not(:first-of-type) {
    margin-top: 8px;
  }
  .detail-file-info {
    margin-left: 6px;
  }
  .detail-file-img {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    object-fit: cover;
  }

  .detail-file-text {
    flex: 1;
    min-height: 0;
    margin-left: 8px;
    font-size: 12px;
    line-height: 1.5;
  }
  .detail-file-size {
    margin-top: 4px;
    color: @text-color-secondary;
  }
  .asset-asset-no {
    color: @orange-6;
  }
</style>
